import React from 'react';
import { BoardPlayer } from '../../hooks/useBoardState';

interface HomeAreaProps {
  player: BoardPlayer;
  isCurrentPlayer: boolean;
  validMoves: number[];
  onPieceClick: (piece: { position: number }, pieceIndex: number) => void;
}

const HomeArea: React.FC<HomeAreaProps> = ({
  player,
  isCurrentPlayer,
  validMoves,
  onPieceClick,
}) => {
  return (
    <div
      className={`${player.color}-box`}
      data-testid={`home-area-${player.color}`}
    >
      <div className="white-box" data-testid={`white-box-${player.color}`}>
        {player.pieces.map((piece, index) => {
          let circleClass = 'circle ';

          if (piece.position === -2) {
            // Finished piece - show in gold/finished state
            circleClass += 'finished';
          } else if (piece.position === -1) {
            // Piece at home - show in player color
            circleClass += player.color;

            // Add highlighting if this piece can be moved out
            if (isCurrentPlayer && validMoves.includes(index)) {
              circleClass += ' highlighted';
            }
          } else {
            // Piece is on board - show as empty
            circleClass += 'empty';
          }

          return (
            <div
              key={index}
              className={circleClass}
              data-testid={`piece-${player.color}-${index}`}
              onClick={() => onPieceClick(piece, index)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default HomeArea;
